import { render, staticRenderFns } from "./tabSetupEvo.vue?vue&type=template&id=6d1beb8a&"
import script from "./tabSetupEvo.vue?vue&type=script&lang=js&"
export * from "./tabSetupEvo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports